import * as React from "react";
import { Route, Redirect, Switch, withRouter, RouteComponentProps } from "react-router-dom";
import PrestupySeznam from "./PrestupySeznam";
import PrestupyDetail from "./PrestupyDetail";
import rootPath, { detailPath as pathPrestupyDetail, RouteProps } from "./routes-path";
import { UserAccess } from "common/utils/PermissionsUtils";

interface PrestupyProps {
    clenId: number;
    userAccess: UserAccess;
}

declare type Props = PrestupyProps & RouteComponentProps<RouteProps>;

class Prestupy extends React.PureComponent<Props> {


    render() {
        const { clenId, userAccess } = this.props;

        return <Switch>
            <Route path={rootPath} exact render={() => <PrestupySeznam clenId={clenId} userAccess={userAccess} />} />
            <Route path={pathPrestupyDetail} render={() => <PrestupyDetail clenId={clenId} />} />

            <Redirect to={rootPath} />
        </Switch>
    }
}

export default withRouter(Prestupy); 
